export var setError = function setError(errorProperties) {
  return function (_ref) {
    var setState = _ref.setState;
    setState({
      error: {
        errorCode: errorProperties.errorCode,
        fieldName: errorProperties.fieldName
      }
    });
  };
};
export var resetError = function resetError() {
  return function (_ref2) {
    var setState = _ref2.setState;
    setState({
      error: null
    });
  };
};